// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getViteSupabasePublishableKey, getViteSupabaseUrl } from '@/lib/supabase-vite-env';

const SUPABASE_URL = getViteSupabaseUrl();
const SUPABASE_PUBLISHABLE_KEY = getViteSupabasePublishableKey();

if (import.meta.env.DEV && (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY)) {
  console.warn(
    "[supabase] Missing VITE_SUPABASE_URL or public key. Set VITE_SUPABASE_PUBLISHABLE_KEY or VITE_SUPABASE_ANON_KEY.",
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});